import { render, staticRenderFns } from "./spectrum.vue?vue&type=template&id=62983675&scoped=true&"
import script from "./spectrum.vue?vue&type=script&lang=js&"
export * from "./spectrum.vue?vue&type=script&lang=js&"
import style0 from "./spectrum.vue?vue&type=style&index=0&id=62983675&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62983675",
  null
  
)

export default component.exports